// material
import { useState, useEffect } from 'react';
import {
    useGridApiRef,
    DataGridPremium
} from "@mui/x-data-grid-premium";
import { Grid, Container, Button, Icon } from '@mui/material';
import plusSquareOutline from "@iconify/icons-eva/plus-square-outline";
// components
import Page from '../../../components/Page';
// ----------------------------------------------------------------------
import { useLazyQuery, useMutation } from '@apollo/client';
import { gql } from '@apollo/client';
import Confirmation from "../../../components/modals/confirmation";
import AddRoleToProject from "./AddRoleToProject";
const CREATE_PROJECT_ROLES = gql`
    mutation createProjectRoles($projectRoles: [InputProjectRoleParams]) {
        createProjectRoles(projectRoles: $projectRoles) {
                id
                role {
                    id
                    name
                }
                project {
                    id
                    name
                }
        }
    }
`
const DELETE_PROJECT_ROLES = gql`
    mutation deleteProjectRoles($ids: [ID]) {
        deleteProjectRoles(ids: $ids) {
            id
        }
    }
`
const GET_ROLES = gql`
query Roles($ids: [ID]) {
  roleTypesByIds(ids: $ids) {
    id
    name
  }}
`;
const GET_PROJECT_ROLES = gql`
query ProjectROles($projectId: ID) {
  projectRoles(projectId: $projectId) {
    id
    role {
        id
        name
    }
    project {
        id
        name
    }
  }
}
`

function renderTableActions(
    project,
    selectionModel,
    openAddRole,
    deleteProjectRoles,
    setConfirmation
) {
    return (
        <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={4}
        >
            <Grid item>
                <h4>Actions: </h4>
            </Grid>
            <Grid item>
                <Button
                    onClick={openAddRole}
                    variant="outlined"
                    startIcon={<Icon icon={plusSquareOutline} />}
                >
                    {`Add New Role(s)`}
                </Button>
            </Grid>
            {selectionModel.length > 0 && (
                <Grid item>
                    <Button
                        onClick={() => {
                            setConfirmation({
                                open: true,
                                action: () => {
                                    deleteProjectRoles({ variables: { ids: selectionModel } })
                                },
                                actionText: `Remove ${selectionModel.length} roles from Project`,
                            });
                        }}
                        variant="outlined"
                        startIcon={<Icon icon={plusSquareOutline} />}
                    >
                        {`Remove ${selectionModel.length} roles from Project`}
                    </Button>
                </Grid>
            )}

        </Grid>
    );
}

export default function ProjectPeople({ project }) {
    const apiRef = useGridApiRef();
    const [roles, setRoles] = useState([]);
    const [projectRoles, setProjectRoles] = useState([]);
    const [addRole, setAddRole] = useState(false);
    const [selectionRecord, setSelectionRecord] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const closeAddRole = () => setAddRole(false)
    const openAddRole = () => setAddRole(true)
    const [confirmation, setConfirmation] = useState({ open: false });
    const closeConfirmation = () => {
        setConfirmation({ open: false });
    };
    let merged = [];
    const [getRoles, getRolesFunctions] = useLazyQuery(GET_ROLES, {
        fetchPolicy: 'network-only',
        onCompleted: (response) => {
            setRoles(response.roleTypesByIds)
        }
    });
    const [getProjectRoles, getProjectRolesFunctions] = useLazyQuery(GET_PROJECT_ROLES, {
        fetchPolicy: 'network-only',
        onCompleted: (response) => {
            setProjectRoles(response.projectRoles)
            getRoles({ variables: { ids: response.projectRoles.map((role) => role.roleId) } })
        }
    });

    const refetch = () => {
        getProjectRolesFunctions.refetch()
        getRolesFunctions.refetch()
    }

    useEffect(() => {
        if (project.id) {
            getProjectRoles({ variables: { projectId: project.id } })
        }
    },
        [project, getProjectRoles])

    const [addRolesToProject] = useMutation(CREATE_PROJECT_ROLES,
        {
            onCompleted: (response) => {
                refetch()
            }
        }
    )

    const [deleteProjectRoles] = useMutation(DELETE_PROJECT_ROLES,
        {
            onCompleted: (response) => {
                refetch()
            }
        }
    )
    if ((projectRoles && projectRoles.length > 0) && (roles && roles.length > 0)) {
        for (let i = 0; i < projectRoles.length; i++) {
            merged.push({
                ...(roles.find((itmInner) => itmInner.id === projectRoles[i].roleId)),
                ...projectRoles[i]
            }
            );
        }
    }
    return (
        <Page title="Projects | FINBACK670">
            <Container maxWidth="xl">
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <AddRoleToProject
                            project={project}
                            open={addRole}
                            handleClose={closeAddRole}
                            addRolesToProject={addRolesToProject}
                            projectRoles={merged}
                            refetchProjectRoles={refetch}
                        />
                        <Confirmation
                            confirmation={confirmation}
                            handleClose={closeConfirmation}
                        />
                        <div style={{ paddingBottom: "16px" }}>
                            {renderTableActions(
                                project,
                                selectionModel,
                                openAddRole,
                                deleteProjectRoles,
                                setConfirmation
                            )}
                        </div>
                        <div style={{ height: 600, width: "100%" }}>
                            <DataGridPremium
                                rows={projectRoles}
                                checkboxSelection={true}
                                apiRef={apiRef}
                                columns={[
                                    {
                                        field: 'role',  // Changed from 'role.name' to just 'role'
                                        headerName: "Role",
                                        valueGetter: (params) => params?.row?.role?.name  // Properly accessing the nested property
                                    }]}
                                pageSize={5}
                                onRowSelectionModelChange={(ids) => {
                                    const selectedIDs = new Set(ids);
                                    const selectedRowData = merged.filter((row) =>
                                        selectedIDs.has(row.id)
                                    );
                                    console.log(selectionRecord)
                                    setSelectionRecord(selectedRowData);
                                    setSelectionModel(ids);
                                }}
                                rowSelectionModel={selectionModel}
                                pageSizeOptions={[50]}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}
